import { inject, Injectable } from '@angular/core';
import { ApiService } from '../../../core/services/api.service';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthResponse } from '../../../core/models/auth.reponse';
import { User } from '../../../core/models/user.model';
import { HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})


export class AuthService extends ApiService {

    router = inject(Router);

    login(loginData: any): Observable<AuthResponse> {
        return this.http.post<AuthResponse>(environment.authUrl + '/token', loginData);
    }


    private refreshTokenTimeout: any;

    refreshToken(): Observable<AuthResponse> {
        const refreshToken = this.getRefreshToken();
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${refreshToken}`
            })
        };
        return this.http.post<AuthResponse>(environment.authUrl + '/refreshtoken', { refreshToken }, httpOptions)
            .pipe(
                map((response) => {
                    this.setToken(response.access_token);
                    this.setRefreshToken(response.refresh_token);
                    this.startRefreshTokenTimer(response.expires_in);
                    return response;
                })
            );
    }

    startRefreshTokenTimer(expiresIn: number) {
        const expires = Number(expiresIn);
        const timeout = (expires - 60) * 1000;
        this.stopRefreshTokenTimer();
        if (timeout > 0) {
            this.refreshTokenTimeout = setTimeout(() => {
                this.refreshToken().subscribe({
                    next: (res) => console.log('Token proactively refreshed'),
                    error: (err) => {
                        console.error('Failed to proactively refresh token', err);
                    }
                });
            }, timeout);
        }
    }

    stopRefreshTokenTimer() {
        if (this.refreshTokenTimeout) {
            clearTimeout(this.refreshTokenTimeout);
            this.refreshTokenTimeout = null;
        }
    }

    getUserInfo() {
        return this.http.get<User>(environment.authUrl + '/userinfo');
    }

    getToken() {
        return localStorage.getItem('icamo_accessToken');
    }

    getRefreshToken() {
        return localStorage.getItem('icamo_refreshToken');
    }

    setToken(token: string) {
        localStorage.setItem('icamo_accessToken', token);
    }

    setRefreshToken(token: string) {
        localStorage.setItem('icamo_refreshToken', token);
    }

    logout() {
        this.stopRefreshTokenTimer();
        localStorage.removeItem('icamo_accessToken');
        localStorage.removeItem('icamo_refreshToken');
        this.router.navigate(['/auth/login']);
    }

    initializeTokenTimer() {
        const token = this.getToken();
        if (token) {
            const payload = this.decodeToken(token);
            // console.log(payload);
            if (payload && payload.exp) {
                const now = Math.floor(Date.now() / 1000);
                const expiresIn = payload.exp - now;
                if (expiresIn > 0) {
                    this.startRefreshTokenTimer(expiresIn);
                } else {
                    this.logout();
                }
            }
        }
    }

    private decodeToken(token: string): any {
        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            console.error('Error decoding token', e);
            return null;
        }
    }
}
